import * as React from 'react';
import Icon from '@mdi/react';
import * as S from './tab-container.styles';

export interface ITab {
    id: string;
    label: string;
    icon?: string;
    count?: number;
}

export interface ITabContainerProps {
    tabs: ITab[];
    activeTab: string;
    onTabChange: (tabId: string) => void;
    children?: React.ReactNode;
}

export class TabContainer extends React.Component<ITabContainerProps> {
    private handleTabClick = (tabId: string) => (e: React.MouseEvent): void => {
        e.preventDefault();
        if (tabId !== this.props.activeTab) {
            this.props.onTabChange(tabId);
        }
    };

    public render(): React.ReactElement {
        const { tabs, activeTab, children } = this.props;

        return (
            <S.TabContainerWrapper>
                <S.TabList role="tablist">
                    {tabs.map((tab, index) => {
                        const isActive = tab.id === activeTab;
                        const zIndex = isActive ? tabs.length : tabs.length - index;
                        const isLastTab = index === tabs.length - 1;
                        const showDivider = !isLastTab && !isActive;
                        
                        return (
                            <React.Fragment key={tab.id}>
                                <S.Tab
                                    role="tab"
                                    aria-selected={isActive}
                                    aria-controls={`tabpanel-${tab.id}`}
                                    tabIndex={isActive ? 0 : -1}
                                    active={isActive}
                                    zIndex={zIndex}
                                    onClick={this.handleTabClick(tab.id)}
                                >
                                    {tab.icon && (
                                        <S.TabIcon active={isActive}>
                                            <Icon path={tab.icon} size={0.67} />
                                        </S.TabIcon>
                                    )}
                                    <S.TabLabel active={isActive}>{tab.label}</S.TabLabel>
                                </S.Tab>
                                {showDivider && <S.TabDivider />}
                            </React.Fragment>
                        );
                    })}
                </S.TabList>
                {children && (
                    <S.TabContent role="tabpanel" id={`tabpanel-${activeTab}`}>
                        {children}
                    </S.TabContent>
                )}
            </S.TabContainerWrapper>
        );
    }
}

